import { css } from '@emotion/react';
import { SurfaceHeader } from '@frontend/surface-header';
import { theme } from '@frontend/theme';
import { CHAT_AREA_WIDTH } from '../../constants';
import { useTeamChatSelector } from '../../providers/team-chat.provider';
import { HeaderExpandCollapseIcon } from '../header-expand-collapse-icon/header-expand-collapse-icon';
import { MentionsList } from './mentions-list';

export const MentionsPanel = () => {
  const isNavExpanded = useTeamChatSelector((ctx) => ctx.isNavExpanded);
  const collapseNav = useTeamChatSelector((ctx) => ctx.collapseNav);
  const closeTeamChat = useTeamChatSelector((ctx) => ctx.closeTeamChat);
  const closeConversation = useTeamChatSelector((ctx) => ctx.closeConversation);
  const onClickBack = () => {
    closeConversation();

    if (isNavExpanded) {
      collapseNav();
    }
  };
  return (
    <div css={styles.container}>
      <SurfaceHeader.Root>
        <SurfaceHeader.Row>
          <SurfaceHeader.Start>
            {!isNavExpanded && (
              <>
                <HeaderExpandCollapseIcon />
                <SurfaceHeader.Icon
                  onClick={onClickBack}
                  iconName='caret-left-small'
                  label='Back'
                  css={styles.back}
                  trackingId='team-chat-2.0-close-mentions-button'
                />
              </>
            )}
          </SurfaceHeader.Start>
          <SurfaceHeader.Title>{`@ Mentions`}</SurfaceHeader.Title>
          <SurfaceHeader.Actions>
            <SurfaceHeader.Icon
              iconName='x'
              onClick={closeTeamChat}
              label='Close Mentions Panel'
              trackingId='team-chat-2.0-close-team-chat-button'
            />
          </SurfaceHeader.Actions>
        </SurfaceHeader.Row>
      </SurfaceHeader.Root>
      <MentionsList />
    </div>
  );
};

const styles = {
  container: css`
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    width: ${CHAT_AREA_WIDTH};
  `,
  icon: css`
    display: inline-block;
    margin-top: -2px;
  `,
  header: css`
    align-items: center;
    border-bottom: 1px solid ${theme.colors.neutral10};
    display: flex;
    padding: ${theme.spacing(1.75, 2, 1.75, 1)};
    gap: ${theme.spacing(1)};
  `,
  back: css`
    min-width: 36px;
    padding: 0;
    width: 36px;
    height: 36px;
  `,
};
